/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Current_SessionInputs */

const en_error_current_session = /** @type {(inputs: Error_Current_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This is the session you're using. To end it, sign out.`)
};

/**
* | output |
* | --- |
* | "This is the session you're using. To end it, sign out." |
*
* @param {Error_Current_SessionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_current_session = /** @type {((inputs?: Error_Current_SessionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Current_SessionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_current_session(inputs)
});